<template>
  <div 
    :class="classList"
    @click="clicked"
    @mouseover="hoverOn"
    @mouseleave="hoverOff"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'default',
  props : {
    content: {
      type: Object,
      required: false,
    },
    styles: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
  },
  emits : ['events'],
  data() {
    return {
      hover: false,
    }
  },
  computed : {
    id() {
      return this.content?.id || ""
    },
    classList() {
      // Import & defaults
      let importOBJ = this.$styles.get(this.styles)
      let iBorder = importOBJ.border || "none"
      iBorder = "border-" + iBorder
      let iBg = importOBJ.bg || "0"
      iBg = "bg-" + iBg
      let iPad = importOBJ.pad  || "none"
      iPad = "pad-" + iPad

      return ['component', 'row', 'cursor-action', iBg, iPad, iBorder]
    },
  },
  methods : {
      hoverOn() {
        this.hover = true
        this.$emit('events', 'hoverOn', this.id)
      },
      hoverOff() {
        this.hover = false
        this.$emit('events', 'hoverOff', this.id) 
      },
      clicked() {
        this.$emit('events', 'clicked', this.id)  
      },
  },
}
</script>

<style scoped>
.component {
  transition : transform .2s;
}
.component:hover {
  background: rgba(40, 40, 186, 0.08);
  border: 12px 12px 0 0;
}
</style>